import { request } from 'network/request'

//获取当前用户信息
export function getUserInfo(from) {
  return request({
    url: '/user',
    method: "get",
    params: {
      from
    }
  })
}
//获取用户信息
export function getOtherInfo(userid) {
  return request({
    url: '/users/' + userid,
    method: "get",
  })
}

//获取全部省市区
export function getAreaJson() {
  return request({
    url: '/area.json',
    method: "get",
  })
}
//修改用户信息
export function getUserEdit(uid, params) {
  return request({
    url: '/users/edit/' + uid,
    method: "post",
    data: params
  })
}
//上传图片、文件
export function getUserUpload(cover_image) {
  return request({
    url: 'https://weixin.ibanling.com/jdzfpaydev/api_upload.php',
    method: "post",
    data: cover_image,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
//用户的关注列表
export function getFollowing(user_id, page) {
  return request({
    url: '/' + user_id + '/following',
    method: "get",
    params: {
      page
    }
  })
}
//
//我发布过的帖子列表
export function getPics(params) {
  return request({
    url: '/topics',
    method: "get",
    params
  })
}
//我点赞过的帖子列表
export function getLikeTopics(page) {
  return request({
    url: '/like_topics',
    method: "get",
    params: {
      page
    }
  })
}
//我评论过的帖子列表
export function getReplyTopics(page) {
  return request({
    url: '/reply_topics',
    method: "get",
    params: {
      page
    }
  })
}


//收藏的帖子
export function getFavoriteTopics(page) {
  return request({
    url: '/favorite_topics',
    method: "get",
    params: {
      page
    }
  })
}
//粉丝
export function getfollowers(user_id, page) {
  return request({
    url: '/' + user_id + '/followers',
    method: "get",
    params: {
      page
    }
  })
}
//获取产品列表
export function getProducts() {
  return request({
    url: '/products',
    method: "get",
  })
}
//兑换记录
export function getRedeemedGifts(page) {
  return request({
    url: '/redeemed_gifts',
    method: "get",
    params: {
      page
    }
  })
}
//兑换记录详情
export function getRedeemedGiftDetail(redeemed_gift_id) {
  return request({
    url: '/redeemed_gifts/' + redeemed_gift_id,
    method: "get",
  })
}
//删除帖子
export function deleteTopics(id) {
  return request({
    url: '/topics/' + id,
    method: "delete",
  })
}
//编辑帖子
export function editTopics(id, data) {
  return request({
    url: '/topics/edit/' + id,
    method: "post",
    data
  })
}
//我的成就
export function getAchievements() {
  return request({
    url: '/achievements',
    method: "get",
  })
}
//发送验证码
export function verification_codes(data) {
  return request({
    url: '/verification_codes',
    method: "post",
    data
  })
}

//领取积分
export function event_add_score(data) {
  return request({
    url: '/event_20140131_add_score',
    method: "post",
    data
  })
}
//查看积分状态
export function get_event_status(data) {
  return request({
    url: '/event_20140131_status',
    method: "get",
    data
  })
}